import { useSiteStore } from "@voix/store/siteStore";
import { useAdminStore } from "@voix/store/adminStore";
import { $voixNuxtApi } from "@voix/voix-layer/composables/voixNuxtApi";
function setSiteInStore(response) {
  if (response) {
    const siteStore = useSiteStore();
    siteStore.currentSite = response.data.value.site;
  }
}
async function getCurrentSite(variables) {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/sites/${variables.domain}`
  );
  setSiteInStore(request.data.value);
  adminStore.isLoading = false;
  return request;
}
function setSitesInStore(response) {
  if (response) {
    const siteStore = useSiteStore();
    siteStore.sites = response;
  }
}
async function getAvailableSites() {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/sites`
  );
  setSitesInStore(request.data.value);
  adminStore.isLoading = false;
  return request;
}
export { getCurrentSite, getAvailableSites };
